// extracted by mini-css-extract-plugin
export default {"settingsTab":"settings_settingsTab__5qsD+","title":"settings_title__dCl04","selected":"settings_selected__AOOPx","opacity-transition":"settings_opacity-transition__8iefT"};